// extracted by mini-css-extract-plugin
export default {"content":"BI","description":"BJ","header":"BK","image":"BL"};